import Seo, { organizationSchema } from "@/lib/Seo";
import PageHero from "@/components/common/PageHero";
import Presentation from "@/components/home/Presentation";
import WhyChoose from "@/components/home/WhyChoose";
import Stats from "@/components/home/Stats";
import CentresPreview from "@/components/home/CentresPreview";

export default function Groupe() {
  return (
    <>
      <Seo
        title="Le Groupe"
        description="Découvrez EDUCASER GROUP, le regroupement d'organismes de formation indépendants dédié aux métiers de la route et de la mobilité : notre vision, notre mission et nos engagements pour la réussite de nos apprenants."
        path="/le-groupe"
        schema={organizationSchema}
      />
      <PageHero
        breadcrumb={[{ label: "Accueil", to: "/" }, { label: "Le Groupe" }]}
        eyebrow="Qui sommes-nous"
        title="Le Groupe EDUCASER"
        intro="Le premier regroupement d'organismes de formation indépendants dédié aux métiers de la route et de la mobilité — transport de marchandises, de voyageurs et enseignement de la conduite."
      />
      <Presentation />
      <Stats />
      <WhyChoose />
      <CentresPreview />
    </>
  );
}
